import Lenis from "lenis";

// Initialize Lenis
export const lenis = new Lenis({
    autoRaf: true,
});
